import { useState, useCallback } from 'react';

import { useParams } from 'src/routes/hooks';

import { getParamValue, type UrlParams } from 'src/utils/url-data-params';

import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE } from 'src/models/recipe/list/pagination-config';

// ----------------------------------------------------------------------

export function useRecipeBrowsePagination() {
  const params = useParams() as unknown as UrlParams;

  const [page, setPage] = useState<number>(parseInt(getParamValue(params, 'page') ?? '', 10) || DEFAULT_PAGE);
  const [pageSize, setPageSize] = useState<number>(parseInt(getParamValue(params, 'pageSize') ?? '', 10) || DEFAULT_PAGE_SIZE);

  const handlePage = useCallback((newPage: number) => {
    setPage(newPage);
  }, []);

  const handlePageSize = useCallback((newPageSize: number) => {
    setPageSize(newPageSize);
  }, []);

  const resetPage = useCallback(() => {
    setPage(DEFAULT_PAGE);
  }, []);

  const clampPage = useCallback((pageCount: number) => {
    if (pageCount > 0) {
      setPage((prev) => Math.min(prev, pageCount));
    }
  }, []);

  return {
    page,
    pageSize,
    handlePage,
    handlePageSize,
    resetPage,
    clampPage,
  };
}

